module.exports = __webpack_public_path__ + "static/media/G1-40-Tamesis-Acalântis-cod81.1ac91213.png";